import styled from 'styled-components'
import vars from 'scss/variables.js'
import ButtonComponent from '@/components/Button'
import CertifiedPurchaseComponent from '../Tag'

const { white, colorGrey9, colorGrey2 } = vars

export const Container = styled.section`
  background-color: ${white};
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 30px 50px;
  box-shadow: 0 2px 9px 0 rgb(158 184 209 / 41%);
`

export const Wrapper = styled.div`
  position: relative;
  border: 2px solid #696977;
  border-radius: 8px;
  padding: 60px 40px 40px 40px;
`

export const CertifiedPurchaseTag = styled(CertifiedPurchaseComponent)`
  position: absolute;
  top: -9px;
  left: -13px;
  background: ${white};
  padding: 0 3px 10px 0;
`

export const Text = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${colorGrey9};
`

export const Highlight = styled.h3`
  margin-top: 24px;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  color: ${colorGrey9};
`

export const List = styled.ul`
  margin: 24px 0 0;
  column-count: 2;
  column-gap: 20px;
`

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-size: 16px;
  font-weight: 500;
  color: #696977;

  &:before {
    content: '';
    display: block;
    width: 20px;
    height: 20px;
    margin-right: 16px;
    background: url('/assets/img/icon-check.svg') no-repeat;
    background-size: 100%;
  }
`

export const StampWrapper = styled.div`
  display: flex;
`

export const StampText = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${colorGrey9};
  margin-top: 24px;
`

export const Button = styled(ButtonComponent)`
  width: 100%;
  max-width: 288px;
  height: 40px;
  margin-top: 32px;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  border-radius: 8;
  text-transform: none;
`

export const PdfNotFound = styled.div`
  display: flex;
  margin-top: 18px;

  p {
    max-width: 390px;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
  }
`

export const AlertIcon = styled.div`
  width: 20px;
  height: 20px;
  margin: 2px 10px 0 0;
  background: url('/assets/img/icon-warning.svg') no-repeat;
  background-size: 100%;
`

export const IconWrapper = styled.div`
  margin-left: auto;
`

export const Icon = styled.div`
  width: 88px;
  height: 88px;
  margin: 0 auto 8px;
  background: url('/assets/img/stamps/garantia.svg') no-repeat;
  background-size: 100%;
`

export const Info = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #696977;
`

export const Footer = styled.div`
  margin-top: 20px;
  padding: 16px 0;
  border-top: 1px solid ${colorGrey2};
`

export const FooterText = styled.p`
  font-size: 12px;
  line-height: 18px;
  color: ${colorGrey9};
  display: inline;
  margin-right: 4px;
`

export const FooterLink = styled.a`
  font-size: 12px;
  line-height: 18px;
  font-weight: 700;
  color: ${colorGrey9};
  cursor: pointer;
`

export const FooterWarningText = styled.p`
  font-size: 9px;
  line-height: 12px;
  text-align: justify;
  font-weight: 400;
  color: #2E2D37;
  margin-right: 8px;
`
